// // import React, { useEffect, useRef, useState } from "react";
// // import { mapTableRows } from "../../../../utils/mapTableRows";
// // import {
// //   Alert,
// //   Button,
// //   FormFieldSet,
// //   Modal,
// //   NewTable,
// //   showToast,
// // } from "../../../../components";
// // import { delegationData } from "../../../../assets/data/candidatesData";
// // import {
// //   clearEmployeeData,
// //   getEmployeesStart,
// //   updateEmployeeStart,
// // } from "../../../../redux/slices/employee/employeeSlice";
// // import { useDispatch, useSelector } from "react-redux";
// // import { usePagination } from "../../../../hooks";
// // import { getEmployeeName } from "../../../../utils/getDisplays";
// // import useDropdownData from "../../../../hooks/useDropdownData";
// // import { getEmployeeId } from "../../../../utils";

// // const DelegationOnBehalf = () => {
// //   const containerRef = useRef(null);

// //   const dispatch = useDispatch();
// //   const { loading, error, employees, totalCount } = useSelector(
// //     (state) => state.employee
// //   );
// //   const [user, setUser] = useState("");
// //   const [employee, setEmployee] = useState("");

// //   // const [changeApproverAlert, setChangeApproverAlert] = useState(false);
// //   // const [removeApproverAlert, setRemoveApproverAlert] = useState(false);
// //   const [changeDelegationModal, setChangeDelegationModal] = useState(false);
// //   const [removeDelegationModal, setRemoveDelegationModal] = useState(false);
// //   const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
// //   const [selectedEmployeeNames, setSelectedEmployeeNames] = useState([]);
// //   console.log("selectedEmployeeNames", selectedEmployeeNames);
// //   console.log("user approver", user);

// //   useEffect(() => {
// //     const fetchEmployees = async () => {
// //       // working one
// //       // const promises = selectedEmployeeIds.map(async (id) => {
// //       //   const name = await getEmployeeName(id);
// //       //   return name;
// //       // });
// //       // const names = await Promise.all(promises);
// //       const namesList =
// //         employees?.data
// //           ?.filter((employee) => selectedEmployeeIds.includes(employee.uiid))
// //           .map((employee) => employee.firstName + " " + employee.lastName) ||
// //         [];
// //       setSelectedEmployeeNames(namesList);
// //       // setSelectedEmployeeNames(names);
// //     };
// //     if (selectedEmployeeIds.length > 0) {
// //       fetchEmployees();
// //     }
// //   }, [selectedEmployeeIds]);
// //   const tableData = delegationData;

// //   // dropdown hook
// //   const {
// //     data: allSelectEmployeeListOptions,
// //     searchValue: allSelectEmployeeSearch,
// //     handleSearch: handleSelectEmployeeSearch,
// //     resetSearch: resetAllSelectEmployeeSearch,
// //     handleScroll: handleAllSelectEmployeeScroll,
// //   } = useDropdownData(
// //     "employeesSorted",
// //     10,
// //     {},
// //     {
// //       classification: 2,
// //     }
// //   );

// //   // pagination hook
// //   const { page, limit, setPage, handleLimitChange } = usePagination(
// //     10,
// //     (newPage, newLimit) => {
// //       dispatch(
// //         getEmployeesStart({
// //           page: newPage,
// //           limit: newLimit,
// //           filters: {
// //             classification: {
// //               type: "NONE",
// //               value: 1,
// //             },
// //           },
// //           sort: { uiid: -1 },
// //           // sort: { uiid: 1 },
// //           ret: "uiid firstName lastName approvalFlow.delegator employmentType",
// //           ref: "Delegator",
// //           incl: "uiid firstName lastName",
// //         })
// //       );
// //     }
// //   );

// //   const columns = [
// //     { key: "employeeName", label: "Employee Name", sortable: false },
// //     {
// //       key: "DelegationOnBehalf",
// //       label: "Delegation on Behalf",
// //       sortable: false,
// //     },
// //   ];

// //   // mapping
// //   // const mappedRows = mapTableRows(tableData, columns);
// //   const mappedRows = mapTableRows(
// //     employees?.data?.map((emp) => ({
// //       id: emp?.uiid,
// //       employeeName: `${emp?.firstName} ${emp?.lastName} (${emp?.uiid})`,
// //       DelegationOnBehalf: emp.approvalFlow?.delegator
// //         ? `${emp.approvalFlow.delegator.firstName} ${
// //             emp.approvalFlow.delegator.lastName
// //           } ${getEmployeeId(
// //             emp?.approvalFlow?.delegator?.uiid,
// //             emp?.approvalFlow?.delegator?.employmentType
// //           )}`
// //         : "-",
// //     })),
// //     columns
// //   );

// //   // getting employees data with delegators
// //   useEffect(() => {
// //     dispatch(
// //       getEmployeesStart({
// //         page: page,
// //         limit: limit,
// //         filters: {
// //           classification: {
// //             type: "NONE",
// //             value: 1,
// //           },
// //         },
// //         sort: { uiid: -1 },
// //         // sort: { uiid: 1 },
// //         ret: "uiid firstName lastName approvalFlow employmentType",
// //         ref: "Delegator",
// //         incl: "uiid firstName lastName",
// //       })
// //     );
// //     return () => {
// //       dispatch(clearEmployeeData());
// //     };
// //   }, [dispatch, page, limit]); // Empty array will cause it to run once when the component mounts

// //   const handleChangeDelegator = async () => {
// //     if (!selectedEmployeeIds.length) {
// //       showToast("Please select an employee", "error", 5000);
// //       return;
// //     }

// //     const updatePromises = selectedEmployeeIds.map((id) => {
// //       return Promise.all([
// //         dispatch(
// //           updateEmployeeStart({
// //             coll: "Employee",
// //             uiid: id,
// //             payload: [
// //               {
// //                 type: "SET",
// //                 value: {
// //                   approvalFlow: {
// //                     delegator: user,
// //                   },
// //                 },
// //               },
// //             ],
// //           })
// //         ),
// //         dispatch(
// //           updateEmployeeStart({
// //             coll: "Employee",
// //             uiid: user,
// //             payload: [
// //               {
// //                 type: "PUSH",
// //                 value: {
// //                   "approvalFlow.delegatedTo": id,
// //                 },
// //               },
// //             ],
// //           })
// //         ),
// //       ]);
// //     });

// //     await Promise.all(updatePromises);

// //     dispatch(
// //       getEmployeesStart({
// //         page,
// //         limit,
// //         filters: {
// //           classification: {
// //             type: "NONE",
// //             value: 1,
// //           },
// //         },
// //         sort: { uiid: -1 },
// //         ret: "uiid firstName lastName approvalFlow employmentType",
// //         ref: "Delegator",
// //         incl: "uiid firstName lastName employmentType",
// //       })
// //     );

// //     setUser("");
// //     setChangeDelegationModal(false);
// //   };

// //   const handleRemoveDelegator = async () => {
// //     if (!selectedEmployeeIds.length) {
// //       showToast("Please select an employee", "error", 5000);
// //       return;
// //     }

// //     try {
// //       const updatePromises = selectedEmployeeIds.map((id) => {
// //         const employee = employees?.data?.find((emp) => emp?.uiid === id);
// //         const delegatorId = employee?.approvalFlow?.delegator?.uiid;

// //         return Promise.all([
// //           dispatch(
// //             updateEmployeeStart({
// //               coll: "Employee",
// //               uiid: id,
// //               payload: [
// //                 {
// //                   type: "SET",
// //                   value: {
// //                     approvalFlow: {
// //                       delegator: null,
// //                     },
// //                   },
// //                 },
// //               ],
// //             })
// //           ),
// //           dispatch(
// //             updateEmployeeStart({
// //               coll: "Employee",
// //               uiid: delegatorId,
// //               payload: [
// //                 {
// //                   type: "PULL",
// //                   value: {
// //                     "approvalFlow.delegatorTo": id,
// //                   },
// //                 },
// //               ],
// //             })
// //           ),
// //         ]);
// //       });

// //       await Promise.all(updatePromises).then(() => {
// //         setRemoveDelegationModal(false);

// //         setTimeout(() => {
// //           dispatch(
// //             getEmployeesStart({
// //               page,
// //               limit,
// //               filters: {
// //                 classification: {
// //                   type: "NONE",
// //                   value: 1,
// //                 },
// //               },
// //               sort: { uiid: -1 },
// //               ret: "uiid firstName lastName approvalFlow employmentType",
// //               ref: "Delegator",
// //               incl: "uiid firstName lastName employmentType",
// //             })
// //           );
// //         }, 1200);
// //       });
// //     } catch (error) {
// //       showToast(
// //         "Failed to remove delegator(s). Please try again.",
// //         "error",
// //         5000
// //       );
// //     }
// //   };

// //   return (
// //     <div>
// //       <NewTable
// //         showCheckbox
// //         rows={mappedRows}
// //         columns={columns}
// //         serverPagination={true}
// //         totalCount={totalCount?.data}
// //         page={page}
// //         limit={limit}
// //         onPageChange={setPage}
// //         onLimitChange={handleLimitChange}
// //         onSelectionChange={(change) => {
// //           setSelectedEmployeeIds(change);
// //         }}
// //         toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
// //         tableWidth={"max-w-7xl"}
// //         customSection={
// //           selectedEmployeeIds.length > 0 && (
// //             <div className="flex gap-1">
// //               <Button
// //                 variant="contained"
// //                 size="sm"
// //                 title={"Change Delegation"}
// //                 color="black"
// //                 // onClick={() => setChangeApproverAlert(true)}
// //                 onClick={() => setChangeDelegationModal(true)}
// //                 icon="person_add"
// //               />
// //               <Button
// //                 variant="contained"
// //                 size="sm"
// //                 title={"Remove Delegation"}
// //                 color="black"
// //                 onClick={() => setRemoveDelegationModal(true)}
// //                 icon="person_remove"
// //               />
// //             </div>
// //           )
// //         }
// //       />
// //       {/* <Alert
// //         isOpen={changeApproverAlert}
// //         onClose={() => setChangeApproverAlert(false)}
// //         title="Change Delegation"
// //         description="Are you sure you want to delete this item? This action cannot be undone."
// //         cancelButton={{
// //           show: true,
// //           title: "Cancel",
// //           onClick: () => console.log("Cancelled"),
// //         }}
// //         acceptButton={{
// //           show: true,
// //           title: "Ok",
// //           onClick: () => console.log("Delete"),
// //         }}
// //       /> */}

// //       <Modal
// //         isOpen={changeDelegationModal}
// //         onClose={() => setChangeDelegationModal(false)}
// //         title="Change Delegation"
// //         width="max-w-4xl"
// //       >
// //         <div>
// //           <div className="flex flex-col max-w-[50%] gap-3">
// //             <div className="">
// //               <FormFieldSet
// //                 type={"select"}
// //                 title={"User"}
// //                 placeholder="Select Approver"
// //                 value={user}
// //                 onChange={setUser}
// //                 options={allSelectEmployeeListOptions}
// //                 keyname="employeesSorted"
// //                 showSearch
// //                 searchValue={allSelectEmployeeSearch}
// //                 onClose={resetAllSelectEmployeeSearch}
// //                 refData={containerRef}
// //                 onSearch={handleSelectEmployeeSearch}
// //                 handleScroll={() => handleAllSelectEmployeeScroll(containerRef)}
// //               />
// //             </div>
// //             <div>
// //               <p>Can submit timesheets on behalf of:</p>
// //             </div>
// //             <div className="">
// //               <FormFieldSet
// //                 type={"textArea"}
// //                 // placeholder=". Aaron carter (CON-2112)"
// //                 placeholder="Selected Employee(s)"
// //                 title="Employee(s)"
// //                 value={selectedEmployeeNames.join(", ")}
// //                 disabled={true}
// //               />
// //             </div>
// //           </div>
// //           <div className="flex gap-3 justify-end">
// //             <Button
// //               variant="outlined"
// //               title={"Cancel"}
// //               onClick={() => {
// //                 setUser("");
// //                 setChangeDelegationModal(false);
// //               }}
// //             />
// //             <Button title={"OK"} onClick={handleChangeDelegator} />
// //           </div>
// //         </div>
// //       </Modal>
// //       <Modal
// //         isOpen={removeDelegationModal}
// //         onClose={() => setRemoveDelegationModal(false)}
// //         title="Remove Delegation"
// //         width="max-w-4xl"
// //       >
// //         <div>
// //           <div className="mb-20">
// //             <p>
// //               Are you sure you want to remove the assigned delegate from the
// //               selected employee(s) ?
// //             </p>
// //           </div>
// //           <div className="flex gap-3 justify-end">
// //             <Button
// //               variant="outlined"
// //               title={"Cancel"}
// //               onClick={() => setRemoveDelegationModal(false)}
// //             />
// //             <Button title={"OK"} onClick={handleRemoveDelegator} />
// //           </div>
// //         </div>
// //       </Modal>
// //     </div>
// //   );
// // };

// // export default DelegationOnBehalf;

// import React, { useEffect, useRef, useState } from "react";
// import { mapTableRows } from "../../../../utils/mapTableRows";
// import {
//   Alert,
//   Backdrop,
//   Button,
//   FormFieldSet,
//   LogoLoader,
//   Modal,
//   NewTable,
//   showToast,
// } from "../../../../components";
// import { delegationData } from "../../../../assets/data/candidatesData";
// import {
//   bulkUpdateEmployeeStart,
//   clearEmployeeData,
//   getEmployeesStart,
//   updateEmployeeStart,
// } from "../../../../redux/slices/employee/employeeSlice";
// import { useDispatch, useSelector } from "react-redux";
// import { usePagination } from "../../../../hooks";
// import { getEmployeeName } from "../../../../utils/getDisplays";
// import useDropdownData from "../../../../hooks/useDropdownData";
// import { getEmployeeId } from "../../../../utils";

// const DelegationOnBehalf = () => {
//   const containerRef = useRef(null);

//   const dispatch = useDispatch();
//   const { loading, error, employees, totalCount } = useSelector(
//     (state) => state.employee,
//   );
//   const [user, setUser] = useState("");
//   const [employee, setEmployee] = useState("");

//   // const [changeApproverAlert, setChangeApproverAlert] = useState(false);
//   // const [removeApproverAlert, setRemoveApproverAlert] = useState(false);
//   const [changeDelegationModal, setChangeDelegationModal] = useState(false);
//   const [removeDelegationModal, setRemoveDelegationModal] = useState(false);
//   const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
//   const [selectedEmployeeNames, setSelectedEmployeeNames] = useState([]);
//   console.log("selectedEmployeeNames", selectedEmployeeNames);
//   console.log("user approver", user);

//   useEffect(() => {
//     const fetchEmployees = async () => {
//       // working one
//       // const promises = selectedEmployeeIds.map(async (id) => {
//       //   const name = await getEmployeeName(id);
//       //   return name;
//       // });
//       // const names = await Promise.all(promises);
//       const namesList =
//         employees?.data
//           ?.filter((employee) =>
//             selectedEmployeeIds.includes(String(employee.uiid)),
//           )
//           .map((employee) =>
//             [employee.firstName, employee.lastName].filter(Boolean).join(" "),
//           ) || [];
//       setSelectedEmployeeNames(namesList);
//       // setSelectedEmployeeNames(names);
//     };
//     if (selectedEmployeeIds.length > 0) {
//       fetchEmployees();
//     }
//   }, [selectedEmployeeIds]);
//   const tableData = delegationData;

//   // dropdown hook
//   const {
//     data: allSelectEmployeeListOptions,
//     searchValue: allSelectEmployeeSearch,
//     handleSearch: handleSelectEmployeeSearch,
//     resetSearch: resetAllSelectEmployeeSearch,
//     handleScroll: handleAllSelectEmployeeScroll,
//   } = useDropdownData(
//     "employeesSorted",
//     10,
//     {},
//     {
//       classification: 2,
//     },
//   );

//   // pagination hook
//   const { page, limit, setPage, handleLimitChange } = usePagination(
//     10,
//     (newPage, newLimit) => {
//       dispatch(
//         getEmployeesStart({
//           page: newPage,
//           limit: newLimit,
//           filters: {
//             classification: {
//               type: "NONE",
//               value: 1,
//             },
//           },
//           sort: { uiid: -1 },
//           // sort: { uiid: 1 },
//           ret: "uiid firstName lastName approvalFlow.delegator employmentType",
//           ref: "Delegator",
//           incl: "uiid firstName lastName",
//         }),
//       );
//     },
//   );

//   const columns = [
//     { key: "employeeName", label: "Employee Name", sortable: false },
//     {
//       key: "DelegationOnBehalf",
//       label: "Delegation on Behalf",
//       sortable: false,
//     },
//   ];

//   // mapping
//   // const mappedRows = mapTableRows(tableData, columns);
//   const mappedRows = mapTableRows(
//     employees?.data?.map((emp) => ({
//       id: emp?.uiid,
//       employeeName: `${[emp?.firstName, emp?.lastName].filter(Boolean).join(" ")} (${getEmployeeId(emp.uiid, emp.employmentType)})`,
//       DelegationOnBehalf: emp.approvalFlow?.delegator
//         ? `${[
//             emp.approvalFlow.delegator.firstName,
//             emp.approvalFlow.delegator.lastName,
//           ]
//             .filter(Boolean)
//             .join(" ")} (${getEmployeeId(
//             emp?.approvalFlow?.delegator?.uiid,
//             emp?.approvalFlow?.delegator?.employmentType,
//           )})`
//         : "-",
//     })),
//     columns,
//   );

//   // getting employees data with delegators
//   useEffect(() => {
//     dispatch(
//       getEmployeesStart({
//         page: page,
//         limit: limit,
//         filters: {
//           classification: {
//             type: "NONE",
//             value: 1,
//           },
//         },
//         sort: { uiid: -1 },
//         // sort: { uiid: 1 },
//         ret: "uiid firstName lastName approvalFlow employmentType",
//         ref: "Delegator",
//         incl: "uiid firstName lastName",
//       }),
//     );
//     return () => {
//       dispatch(clearEmployeeData());
//     };
//   }, [dispatch, page, limit]); // Empty array will cause it to run once when the component mounts

//   //working
//   // const handleChangeDelegator = async () => {
//   //   if (!selectedEmployeeIds.length) {
//   //     showToast("Please select an employee", "error", 5000);
//   //     return;
//   //   }

//   //   const updatePromises = selectedEmployeeIds.map((id) => {
//   //     return Promise.all([
//   //       dispatch(
//   //         updateEmployeeStart({
//   //           coll: "Employee",
//   //           uiid: id,
//   //           payload: [
//   //             {
//   //               type: "SET",
//   //               value: {
//   //                 approvalFlow: {
//   //                   delegator: user,
//   //                 },
//   //               },
//   //             },
//   //           ],
//   //         })
//   //       ),
//   //       dispatch(
//   //         updateEmployeeStart({
//   //           coll: "Employee",
//   //           uiid: user,
//   //           payload: [
//   //             {
//   //               type: "PUSH",
//   //               value: {
//   //                 "approvalFlow.delegatedTo": id,
//   //               },
//   //             },
//   //           ],
//   //         })
//   //       ),
//   //     ]);
//   //   });

//   //   await Promise.all(updatePromises);

//   //   dispatch(
//   //     getEmployeesStart({
//   //       page,
//   //       limit,
//   //       filters: {
//   //         classification: {
//   //           type: "NONE",
//   //           value: 1,
//   //         },
//   //       },
//   //       sort: { uiid: -1 },
//   //       ret: "uiid firstName lastName approvalFlow employmentType",
//   //       ref: "Delegator",
//   //       incl: "uiid firstName lastName employmentType",
//   //     })
//   //   );

//   //   setUser("");
//   //   setChangeDelegationModal(false);
//   // };

//   //testing
//   const handleChangeDelegator = async () => {
//     if (!selectedEmployeeIds.length) {
//       showToast("Please select an employee", "error", 5000);
//       return;
//     }

//     try {
//       dispatch(
//         bulkUpdateEmployeeStart({
//           coll: "Employee",
//           uiid: null,
//           payload: [
//             {
//               type: "UPDATEMANY",
//               value: {
//                 type: "SET",
//                 value: {
//                   "approvalFlow.delegator": user,
//                 },
//                 fil: {
//                   uiid: { type: "IN", value: selectedEmployeeIds },
//                 },
//               },
//             },
//             {
//               type: "UPDATEONE",
//               value: {
//                 type: "PUSH",
//                 value: {
//                   "approvalFlow.delegatedTo": selectedEmployeeIds,
//                 },
//                 fil: {
//                   uiid: { type: "NONE", value: user },
//                 },
//               },
//             },
//           ],
//           onSuccess: () => {
//             dispatch(
//               getEmployeesStart({
//                 page,
//                 limit,
//                 filters: {
//                   classification: {
//                     type: "NONE",
//                     value: 1,
//                   },
//                 },
//                 sort: { uiid: -1 },
//                 ret: "uiid firstName lastName approvalFlow employmentType",
//                 ref: "Delegator",
//                 incl: "uiid firstName lastName employmentType",
//               }),
//             );
//           },
//         }),
//       );

//       // dispatch(
//       //   getEmployeesStart({
//       //     page,
//       //     limit,
//       //     filters: {
//       //       classification: {
//       //         type: "NONE",
//       //         value: 1,
//       //       },
//       //     },
//       //     sort: { uiid: -1 },
//       //     ret: "uiid firstName lastName approvalFlow employmentType",
//       //     ref: "Delegator",
//       //     incl: "uiid firstName lastName employmentType",
//       //   })
//       // );

//       setUser("");
//       setChangeDelegationModal(false);
//     } catch (err) {
//       showToast("Failed to change delegator. Try again.", "error", 5000);
//     }
//   };

//   const handleRemoveDelegator = async () => {
//     if (!selectedEmployeeIds.length) {
//       showToast("Please select an employee", "error", 5000);
//       return;
//     }

//     try {
//       const updatePromises = selectedEmployeeIds.map((id) => {
//         const employee = employees?.data?.find(
//           (emp) => String(emp?.uiid) === id,
//         );
//         const delegatorId = employee?.approvalFlow?.delegator?.uiid;

//         return Promise.all([
//           dispatch(
//             updateEmployeeStart({
//               coll: "Employee",
//               uiid: id,
//               payload: [
//                 {
//                   type: "SET",
//                   value: {
//                     approvalFlow: {
//                       delegator: null,
//                     },
//                   },
//                 },
//               ],
//             }),
//           ),
//           dispatch(
//             updateEmployeeStart({
//               coll: "Employee",
//               uiid: delegatorId,
//               payload: [
//                 {
//                   type: "PULL",
//                   value: {
//                     "approvalFlow.delegatorTo": id,
//                   },
//                 },
//               ],
//             }),
//           ),
//         ]);
//       });

//       await Promise.all(updatePromises).then(() => {
//         setRemoveDelegationModal(false);

//         setTimeout(() => {
//           dispatch(
//             getEmployeesStart({
//               page,
//               limit,
//               filters: {
//                 classification: {
//                   type: "NONE",
//                   value: 1,
//                 },
//               },
//               sort: { uiid: -1 },
//               ret: "uiid firstName lastName approvalFlow employmentType",
//               ref: "Delegator",
//               incl: "uiid firstName lastName employmentType",
//             }),
//           );
//         }, 1200);
//       });
//     } catch (error) {
//       showToast(
//         "Failed to remove delegator(s). Please try again.",
//         "error",
//         5000,
//       );
//     }
//   };

//   return (
//     <div className="flex-1 flex overflow-hidden">
//       <Backdrop isOpen={loading}>
//         <LogoLoader />
//       </Backdrop>
//       <NewTable
//         showCheckbox
//         rows={mappedRows}
//         columns={columns}
//         serverPagination={true}
//         totalCount={totalCount?.data}
//         page={page}
//         limit={limit}
//         onPageChange={setPage}
//         onLimitChange={handleLimitChange}
//         onSelectionChange={(change) => {
//           setSelectedEmployeeIds(change);
//         }}
//         toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
//         tableWidth={"max-w-7xl"}
//         customSection={
//           selectedEmployeeIds.length > 0 && (
//             <div className="flex gap-1">
//               <Button
//                 variant="contained"
//                 size="sm"
//                 title={"Change Delegation"}
//                 color="black"
//                 // onClick={() => setChangeApproverAlert(true)}
//                 onClick={() => setChangeDelegationModal(true)}
//                 icon="person_add"
//               />
//               <Button
//                 variant="contained"
//                 size="sm"
//                 title={"Remove Delegation"}
//                 color="black"
//                 onClick={() => setRemoveDelegationModal(true)}
//                 icon="person_remove"
//               />
//             </div>
//           )
//         }
//       />
//       {/* <Alert
//         isOpen={changeApproverAlert}
//         onClose={() => setChangeApproverAlert(false)}
//         title="Change Delegation"
//         description="Are you sure you want to delete this item? This action cannot be undone."
//         cancelButton={{
//           show: true,
//           title: "Cancel",
//           onClick: () => console.log("Cancelled"),
//         }}
//         acceptButton={{
//           show: true,
//           title: "Ok",
//           onClick: () => console.log("Delete"),
//         }}
//       /> */}

//       <Modal
//         isOpen={changeDelegationModal}
//         onClose={() => setChangeDelegationModal(false)}
//         title="Change Delegation"
//         width="max-w-4xl"
//       >
//         <div>
//           <div className="flex flex-col max-w-[50%] gap-3">
//             <div className="">
//               <FormFieldSet
//                 type={"select"}
//                 title={"User"}
//                 placeholder="Select Approver"
//                 value={user}
//                 onChange={setUser}
//                 options={allSelectEmployeeListOptions}
//                 keyname="employeesSorted"
//                 showSearch
//                 searchValue={allSelectEmployeeSearch}
//                 onClose={resetAllSelectEmployeeSearch}
//                 refData={containerRef}
//                 onSearch={handleSelectEmployeeSearch}
//                 handleScroll={() => handleAllSelectEmployeeScroll(containerRef)}
//               />
//             </div>
//             <div>
//               <p>Can submit timesheets on behalf of:</p>
//             </div>
//             <div className="">
//               <FormFieldSet
//                 type={"textArea"}
//                 // placeholder=". Aaron carter (CON-2112)"
//                 placeholder="Selected Employee(s)"
//                 title="Employee(s)"
//                 value={selectedEmployeeNames.join(", ")}
//                 disabled={true}
//               />
//             </div>
//           </div>
//           <div className="flex gap-3 justify-end">
//             <Button
//               variant="outlined"
//               title={"Cancel"}
//               onClick={() => {
//                 setUser("");
//                 setChangeDelegationModal(false);
//               }}
//             />
//             <Button title={"OK"} onClick={handleChangeDelegator} />
//           </div>
//         </div>
//       </Modal>
//       <Modal
//         isOpen={removeDelegationModal}
//         onClose={() => setRemoveDelegationModal(false)}
//         title="Remove Delegation"
//         width="max-w-4xl"
//       >
//         <div>
//           <div className="mb-20">
//             <p>
//               Are you sure you want to remove the assigned delegate from the
//               selected employee(s) ?
//             </p>
//           </div>
//           <div className="flex gap-3 justify-end">
//             <Button
//               variant="outlined"
//               title={"Cancel"}
//               onClick={() => setRemoveDelegationModal(false)}
//             />
//             <Button title={"OK"} onClick={handleRemoveDelegator} />
//           </div>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default DelegationOnBehalf;
import React, { useEffect, useRef, useState } from "react";
import { mapTableRows } from "../../../../utils/mapTableRows";
import {
  Alert,
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  Modal,
  TableAdv,
  showToast,
} from "../../../../components";
import { delegationData } from "../../../../assets/data/candidatesData";
import {
  bulkUpdateEmployeeStart,
  clearEmployeeData,
  getEmployeesStart,
  updateEmployeeStart,
} from "../../../../redux/slices/employee/employeeSlice";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../hooks";
import { getEmployeeName } from "../../../../utils/getDisplays";
import useDropdownData from "../../../../hooks/useDropdownData";
import { getEmployeeId } from "../../../../utils";

const DelegationOnBehalf = () => {
  const containerRef = useRef(null);

  const dispatch = useDispatch();
  const { loading, error, employees, totalCount } = useSelector(
    (state) => state.employee,
  );
  const [user, setUser] = useState("");
  const [employee, setEmployee] = useState("");

  const [changeDelegationModal, setChangeDelegationModal] = useState(false);
  const [removeDelegationModal, setRemoveDelegationModal] = useState(false);
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  const [selectedEmployeeNames, setSelectedEmployeeNames] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  console.log("selectedEmployeeNames", selectedEmployeeNames);
  console.log("user approver", user);

  useEffect(() => {
    const fetchEmployees = async () => {
      const namesList =
        employees?.data
          ?.filter((employee) =>
            selectedEmployeeIds.includes(String(employee.uiid)),
          )
          .map((employee) =>
            [employee.firstName, employee.lastName].filter(Boolean).join(" "),
          ) || [];
      setSelectedEmployeeNames(namesList);
    };
    if (selectedEmployeeIds.length > 0) {
      fetchEmployees();
    }
  }, [selectedEmployeeIds]);

  const tableData = delegationData;

  // dropdown hook
  const {
    data: allSelectEmployeeListOptions,
    searchValue: allSelectEmployeeSearch,
    handleSearch: handleSelectEmployeeSearch,
    resetSearch: resetAllSelectEmployeeSearch,
    handleScroll: handleAllSelectEmployeeScroll,
  } = useDropdownData(
    "employeesSorted",
    10,
    {},
    {
      classification: 2,
    },
  );

  // pagination hook
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(
        getEmployeesStart({
          page: newPage,
          limit: newLimit,
          filters: {
            classification: {
              type: "NONE",
              value: 1,
            },
            employmentType: {
              type: "IN",
              value: [1,3],
            },
          },
          sort: { uiid: -1 },
          ret: "uiid firstName lastName approvalFlow.delegator employmentType",
          ref: "Delegator",
          incl: "uiid firstName lastName",
        }),
      );
    },
  );

  const columns = [
    { key: "employeeName", label: "Employee Name", sortable: false },
    {
      key: "DelegationOnBehalf",
      label: "Delegation on Behalf",
      sortable: false,
    },
  ];

  // mapping with proper id field
  const mappedRows = mapTableRows(
    employees?.data?.map((emp) => ({
      id: emp?.uiid, // Important for TableAdv
      uiid: emp?.uiid,
      employeeName: `${[emp?.firstName, emp?.lastName].filter(Boolean).join(" ")} (${getEmployeeId(emp.uiid, emp.employmentType)})`,
      DelegationOnBehalf: emp.approvalFlow?.delegator
        ? `${[
            emp.approvalFlow.delegator.firstName,
            emp.approvalFlow.delegator.lastName,
          ]
            .filter(Boolean)
            .join(" ")} (${getEmployeeId(
            emp?.approvalFlow?.delegator?.uiid,
            emp?.approvalFlow?.delegator?.employmentType,
          )})`
        : "-",
    })) || [],
    columns,
  );

  // getting employees data with delegators
  useEffect(() => {
    dispatch(
      getEmployeesStart({
        page: page,
        limit: limit,
        filters: {
          classification: {
            type: "NONE",
            value: 1,
          },
          employmentType: {
            type: "IN",
            value: [1,3],
          },
        },
        sort: { uiid: -1 },
        ret: "uiid firstName lastName approvalFlow employmentType",
        ref: "Delegator",
        incl: "uiid firstName lastName",
      }),
    );
    return () => {
      dispatch(clearEmployeeData());
    };
  }, [dispatch, page, limit]);

  const handleChangeDelegator = async () => {
    if (!selectedEmployeeIds.length) {
      showToast("Please select an employee", "error", 5000);
      return;
    }

    try {
      dispatch(
        bulkUpdateEmployeeStart({
          coll: "Employee",
          uiid: null,
          payload: [
            {
              type: "UPDATEMANY",
              value: {
                type: "SET",
                value: {
                  "approvalFlow.delegator": user,
                },
                fil: {
                  uiid: { type: "IN", value: selectedEmployeeIds },
                },
              },
            },
            {
              type: "UPDATEONE",
              value: {
                type: "PUSH",
                value: {
                  "approvalFlow.delegatedTo": selectedEmployeeIds,
                },
                fil: {
                  uiid: { type: "NONE", value: user },
                },
              },
            },
          ],
          onSuccess: () => {
            dispatch(
              getEmployeesStart({
                page,
                limit,
                filters: {
                  classification: {
                    type: "NONE",
                    value: 1,
                  },
                  employmentType: {
                    type: "IN",
                    value: [1,3],
                  },
                },
                sort: { uiid: -1 },
                ret: "uiid firstName lastName approvalFlow employmentType",
                ref: "Delegator",
                incl: "uiid firstName lastName employmentType",
              }),
            );
          },
        }),
      );

      setUser("");
      setChangeDelegationModal(false);
    } catch (err) {
      showToast("Failed to change delegator. Try again.", "error", 5000);
    }
  };

  const handleRemoveDelegator = async () => {
    if (!selectedEmployeeIds.length) {
      showToast("Please select an employee", "error", 5000);
      return;
    }

    try {
      const updatePromises = selectedEmployeeIds.map((id) => {
        const employee = employees?.data?.find(
          (emp) => String(emp?.uiid) === id,
        );
        const delegatorId = employee?.approvalFlow?.delegator?.uiid;

        return Promise.all([
          dispatch(
            updateEmployeeStart({
              coll: "Employee",
              uiid: id,
              payload: [
                {
                  type: "SET",
                  value: {
                    approvalFlow: {
                      delegator: null,
                    },
                  },
                },
              ],
            }),
          ),
          dispatch(
            updateEmployeeStart({
              coll: "Employee",
              uiid: delegatorId,
              payload: [
                {
                  type: "PULL",
                  value: {
                    "approvalFlow.delegatorTo": id,
                  },
                },
              ],
            }),
          ),
        ]);
      });

      await Promise.all(updatePromises).then(() => {
        setRemoveDelegationModal(false);

        setTimeout(() => {
          dispatch(
            getEmployeesStart({
              page,
              limit,
              filters: {
                classification: {
                  type: "NONE",
                  value: 1,
                },
              },
              sort: { uiid: -1 },
              ret: "uiid firstName lastName approvalFlow employmentType",
              ref: "Delegator",
              incl: "uiid firstName lastName employmentType",
            }),
          );
        }, 1200);
      });
    } catch (error) {
      showToast(
        "Failed to remove delegator(s). Please try again.",
        "error",
        5000,
      );
    }
  };

  // Handle selection change from TableAdv
  const handleSelectionChange = (selectedRowIds) => {
    console.log("Selected row IDs from TableAdv:", selectedRowIds);
    console.log("All mapped rows:", mappedRows);

    setSelectedRows(selectedRowIds);

    // Find the actual row objects from mappedRows
    const selectedRowObjects = mappedRows.filter((row) =>
      selectedRowIds.includes(row.id),
    );

    console.log("Selected row objects:", selectedRowObjects);

    // Extract employee IDs (convert to string to match the format used in other functions)
    const employeeIds = selectedRowObjects.map((row) =>
      String(row.uiid || row.id),
    );

    console.log("Extracted employee IDs:", employeeIds);

    setSelectedEmployeeIds(employeeIds);
  };

  return (
    <div className="flex-1 flex overflow-hidden">
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <TableAdv
        showCheckbox
        rows={mappedRows}
        columns={columns}
        serverPagination={true}
        totalCount={totalCount?.data}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        onSelectionChange={handleSelectionChange}
        defaultSelectedRows={selectedRows}
        toolbarRight={{
          filter: false,
          search: false,
          add: [
            {
              component: selectedEmployeeIds.length > 0 && (
                <div className="flex gap-2">
                  <Button
                    variant="contained"
                    size="sm"
                    title={"Change Delegation"}
                    color="black"
                    onClick={() => setChangeDelegationModal(true)}
                    icon="person_add"
                  />
                  <Button
                    variant="contained"
                    size="sm"
                    title={"Remove Delegation"}
                    color="black"
                    onClick={() => setRemoveDelegationModal(true)}
                    icon="person_remove"
                  />
                </div>
              ),
            },
          ],
        }}
        tableId="delegation-behalf-table"
      />

      <Modal
        isOpen={changeDelegationModal}
        onClose={() => setChangeDelegationModal(false)}
        title="Change Delegation"
        width="max-w-4xl"
      >
        <div>
          <div className="flex flex-col max-w-[80%] lg:max-w-[65%] xl:max-w-[50%] gap-3">
            <div className="">
              <FormFieldSet
                type={"select"}
                title={"User"}
                placeholder="Select Approver"
                value={user}
                onChange={setUser}
                options={allSelectEmployeeListOptions}
                keyname="employeesSorted"
                showSearch
                searchValue={allSelectEmployeeSearch}
                onClose={resetAllSelectEmployeeSearch}
                refData={containerRef}
                onSearch={handleSelectEmployeeSearch}
                handleScroll={() => handleAllSelectEmployeeScroll(containerRef)}
              />
            </div>
            <div>
              <p>Can submit timesheets on behalf of:</p>
            </div>
            <div className="">
              <FormFieldSet
                type={"textArea"}
                placeholder="Selected Employee(s)"
                title="Employee(s)"
                value={selectedEmployeeNames.join(", ")}
                disabled={true}
              />
            </div>
          </div>
          <div className="flex gap-3 justify-end mt-2">
            <Button
              variant="outlined"
              title={"Cancel"}
              onClick={() => {
                setUser("");
                setChangeDelegationModal(false);
              }}
            />
            <Button title={"OK"} onClick={handleChangeDelegator} />
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={removeDelegationModal}
        onClose={() => setRemoveDelegationModal(false)}
        title="Remove Delegation"
        width="max-w-4xl"
      >
        <div>
          <div className="mb-20">
            <p>
              Are you sure you want to remove the assigned delegate from the
              selected employee(s) ?
            </p>
          </div>
          <div className="flex gap-3 justify-end">
            <Button
              variant="outlined"
              title={"Cancel"}
              onClick={() => setRemoveDelegationModal(false)}
            />
            <Button title={"OK"} onClick={handleRemoveDelegator} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DelegationOnBehalf;